import { useEffect, useState } from 'react';

/**
 * `value`, once it has stopped changing for `delayMs`.
 *
 * For search boxes that ask the server (MYP-126): every keystroke still updates the box and the
 * URL at once, but the request waits for a pause, so typing a tracking number sends one search
 * rather than one per character. An emptied box is passed through at once — clearing a search
 * should feel instant.
 */
export function useDebounced(value: string, delayMs = 400): string {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    if (value.trim() === '') {
      setSettled(value);
      return;
    }
    const timer = window.setTimeout(() => setSettled(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
